import {Component, OnInit} from '@angular/core';
import {UserSuggestedReportsService} from "./user-suggested-reports.service";
import {Report} from "../../model/report";
import {User} from "../../model/user";
import {NotifierService} from "../notifier/notifier.service";
import {NotificationType} from "../notifier/notification-type.enum";
import {CommonService} from "../../common/common.service";
import {forkJoin} from "rxjs/observable/forkJoin";
import {Dictionary} from "../../model/dictionary";
import {saveAs} from "file-saver";
import {UserSuggestedReportsPagerService} from "./user-suggested-reports-pager.service";
import {UserReportsService} from "../user-reports/user-reports.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";
import {UserSavedReportsService} from '../user-saved-reports/user-saved-reports.service';
import {TopMenuService} from "../top-menu/top-menu.service";

@Component({
  selector: 'pbc-user-suggested-reports',
  templateUrl: './user-suggested-reports.component.html',
  styleUrls: ['./user-suggested-reports.component.scss']
})
export class UserSuggestedReportsComponent implements OnInit {

  suggestedReports : Array<Report> = [];
  private reportShowMoreList : Array<Report> = [];
  private loggedUser : User;

  reportToOperateOn : Report;

  showReportSharePopup : boolean = false;

  //Filtrowanie
  showFilterPopup : boolean = false;
  reportsAreFiltered : boolean = false;
  filteredReportsCounter : number = 0;
  numberOfFilterCriteria : number = 0;

  contentTypes : Array<Dictionary> = [];
  contentTypesSelected : Array<Dictionary> = [];
  fileFormats : Array<string> = [];
  fileFormatsSelected : Array<string> = [];
  thematicsAreas : Array<Dictionary> = [];
  thematicsAreasSelected : Array<Dictionary> = [];
  thematicsClientGroups : Array<Dictionary> = [];
  thematicsClientGroupsSelected : Array<Dictionary> = [];
  thematicsInstitutions : Array<Dictionary> = [];
  thematicsInstitutionsSelected : Array<Dictionary> = [];
  thematicsProducts : Array<Dictionary> = [];
  thematicsProductsSelected : Array<Dictionary> = [];
  thematicsPublicationFrequencies : Array<Dictionary> = [];
  thematicsPublicationFrequenciesSelected : Array<Dictionary> = [];

  //Sortowania
  orderByField : string = "publishFrom";
  orderAsc : boolean =  false;

  //Pager
  pager: any = new Object();
  private static pageSize: number = 10;
  pagedSuggestedReports : Array<Report> = [];
  currentPage : number = 1;

  //Sugerowane raporty
  showDownloadDemoPopup : boolean = false;

  //Udostepnianie raportow
  shareReportForm : FormGroup;
  //Zapytanie o ofertę dotyczącą konkretnego raportu
  contactForm : FormGroup;
  contactFormMessage : string = '';
  showContactFormPopup : boolean = false;

  constructor(private suggestedReportsService : UserSuggestedReportsService,
              private notifierService : NotifierService,
              private suggesterReportsPagerService : UserSuggestedReportsPagerService,
              private userReportsService : UserReportsService,
              private commonService : CommonService,
              private userSavedReportsService: UserSavedReportsService,
              private topMenuService: TopMenuService,
              private breadcumbsService: BreadcumbsService) { }

  ngOnInit() {
    let authData = JSON.parse(localStorage.getItem('auth_data'));
    this.loggedUser = authData.user;
    const userName = authData.user.firstName + ' ' + authData.user.lastName;
    this.suggestedReportsService.deactivateTopMenuActivePosition.emit(true);

    this.shareReportForm = new FormGroup({
      'email' : new FormControl('', [Validators.email, Validators.required]),
      'message' : new FormControl('Dzień dobry, być może zainteresuje Cię ten raport. Pozdrawiam, ' + userName),
      'sendCopy' : new FormControl(false)
    });
    this.contactForm = new FormGroup({
      'email' : new FormControl({value:this.loggedUser.email, disabled : true},
        [Validators.email, Validators.required]),
      'firstLastName' : new FormControl(
        {value: this.loggedUser.firstName.concat(' ', this.loggedUser.lastName), disabled : true}, Validators.required),
      'phoneNumber' : new FormControl({value: this.loggedUser.workPhone, disabled  : true}),
      'message' : new FormControl(this.contactFormMessage, Validators.required),
      'sendCopy' : new FormControl(false),
      'agreement' : new FormControl(false, Validators.requiredTrue)
    });

    this.getDictionaries();
    this.getSuggestedReports(true);

  }

  showReportSharePopupClick(report: Report) {
    this.reportToOperateOn = report;
    this.showReportSharePopup = true;
  }

  closeReportSharePopupClick() {
    this.showReportSharePopup = false;
    this.reportToOperateOn = undefined;
    let authData = JSON.parse(localStorage.getItem('auth_data'));
    const userName = authData.user.firstName + ' ' + authData.user.lastName;
    this.shareReportForm.controls['email'].reset('');
    this.shareReportForm.controls['message'].reset('Dzień dobry, być może zainteresuje Cię ten raport. Pozdrawiam, ' + userName);
    this.shareReportForm.controls['sendCopy'].reset(false);
  }

  shareReportClick() {
    let email = this.shareReportForm.controls['email'].value;
    let message = this.shareReportForm.controls['message'].value;
    let authData = JSON.parse(localStorage.getItem('auth_data'));
    const userName = authData.user.firstName + ' ' + authData.user.lastName;
    this.commonService.shareReport(this.reportToOperateOn.id, this.loggedUser.id, email, message).subscribe(
      result=>{
        if (result.status==1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Wysłano link do raportu");
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd: Link nie został wysłany");

        this.showReportSharePopup = false;
        this.reportToOperateOn = undefined;
        this.shareReportForm.controls['email'].reset('');
        this.shareReportForm.controls['message'].reset('Dzień dobry, być może zainteresuje Cię ten raport. Pozdrawiam, ' + userName);
        this.shareReportForm.controls['sendCopy'].reset(false);
      });
  }

  updateUserReportsCount(){
    let filterParams = {};
    filterParams['id']=this.loggedUser.id;
    this.userSavedReportsService.getReportsCount(filterParams).subscribe(
        result => {
          this.topMenuService.userReportsCount.emit(result.record);
        })
  }


  private getSuggestedReports(returnResult : boolean) {
    let filterParams = {};

    filterParams['id']=this.loggedUser.id;

    if (this.contentTypesSelected.length > 0)
      filterParams['content_type'] = this.contentTypesSelected.map(contentType => contentType.id);

    filterParams['sortString'] = this.createSortString();

    if (this.fileFormatsSelected.length > 0)
      filterParams['fileFormat'] = this.fileFormatsSelected;

    if (this.thematicsAreasSelected.length > 0)
      filterParams['thematics_area'] = this.thematicsAreasSelected.map((area:Dictionary)=>area.id);
    if (this.thematicsClientGroupsSelected.length > 0)
      filterParams['thematics_client_groups'] = this.thematicsClientGroupsSelected.map((clientGroup : Dictionary)=>clientGroup.id);
    if (this.thematicsInstitutionsSelected.length > 0)
      filterParams['thematics_institution'] = this.thematicsInstitutionsSelected.map((institution:Dictionary)=>institution.id);
    if (this.thematicsProductsSelected.length > 0)
      filterParams['thematics_products'] = this.thematicsProductsSelected.map((product:Dictionary)=>product.id);
    if (this.thematicsPublicationFrequenciesSelected.length > 0)
      filterParams['thematics_frequency'] = this.thematicsPublicationFrequenciesSelected.map((freq:Dictionary)=>freq.id);

    this.suggestedReportsService.getSuggestedReports(filterParams).subscribe(
      data => {
        if (data.status != 1) {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy sugerowanych raportów');
        } else {
          if (returnResult) {
            this.suggestedReports = data.record;
            this.filteredReportsCounter = this.suggestedReports.length;
            this.setPage(this.currentPage);
          } else
            this.filteredReportsCounter = data.record.length;
        }
        setTimeout(()=>this.breadcumbsService.setSubfolder.emit('Wybrane dla ciebie'),100);
      },
      error =>{
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy sugerowanych raportów');
      }
    )
  }

  orderByClick(orderByField : string) {
    if (orderByField === this.orderByField)
      this.orderAsc = !this.orderAsc;
    else {
      this.orderAsc = true;
      this.orderByField = orderByField;
    }
    this.getSuggestedReports(true);
  }

  private createSortString() : string {
    let sortString = '';
    if (this.orderAsc)
      sortString = this.orderByField.concat(" ASC");
    else
      sortString = this.orderByField.concat(" DESC");

    return sortString;
  }

  setPage(page: number) {
    // get pager object from service
    this.pager = this.suggesterReportsPagerService.getPager(this.suggestedReports.length, page, UserSuggestedReportsComponent.pageSize);
    this.currentPage = page;

    // get current page of items
    this.pagedSuggestedReports = this.suggestedReports.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  modifySelectedElementList(elementList : Array<string>, id : string, showResults? : boolean) {
    if (showResults === undefined)
      showResults = false;

    let position = elementList.indexOf(id);
    if (position === -1)
      elementList.push(id);
    else
      elementList.splice(position, 1);

    this.numberOfFilterCriteria = this.fileFormatsSelected.length
      + this.thematicsAreasSelected.length
      + this.thematicsClientGroupsSelected.length
      + this.thematicsPublicationFrequenciesSelected.length
      + this.thematicsInstitutionsSelected.length
      + this.thematicsProductsSelected.length
      + this.contentTypesSelected.length;

    this.getSuggestedReports(showResults);
  }


  private addRemoveReportShowMoreList(report : Report) {
    let position = this.reportShowMoreList.indexOf(report);
    if (position == -1) {
      this.reportShowMoreList.push(report);
      this.commonService.registerClickOnElement('rollDown','suggestedReportsList','report', report.id).subscribe(
        success=>{
          if (success.status != 1)
            console.log(success.message);
        },
        error => {
          console.log(error);
        }
      );
    } else {
      this.reportShowMoreList.splice(position, 1);
      this.commonService.registerClickOnElement('rollUp','suggestedReportsList','report', report.id).subscribe(
        success=>{
          if (success.status != 1)
            console.log(success.message);
        },
        error => {
          console.log(error);
        }
      );
    }
  }

  private getDictionaries() {

    forkJoin(
      this.commonService.getAreaDictionary(),
      this.commonService.getClientGroupsDictionary(),
      this.commonService.getInstitutionDictionary(),
      this.commonService.getProductsDictionary(),
      this.commonService.getFrequencyDictionary(),
      this.commonService.getContentTypeDictionary(),
      this.userReportsService.getFileFormats()
    ).subscribe(([areas, clientGroups, institutions, products, frequencies, contentTypes, fileFormats]) => {
        this.thematicsAreas= areas;
        this.thematicsClientGroups = clientGroups;
        this.thematicsInstitutions = institutions;
        this.thematicsProducts= products;
        this.thematicsPublicationFrequencies= frequencies;
        this.contentTypes = contentTypes;
        this.fileFormats = fileFormats;
      },
      (error) => {
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie pobrano słowników");
        console.log("Wystąpił błąd! Nie pobrano słowników:", JSON.stringify(error));
      });
  }

  showFilterPopupClick(show : boolean) {
    this.showFilterPopup = show;
  }

  private addToFavouritesClick(report : Report) {
    this.suggestedReportsService.addToFavourites(report.id, this.loggedUser.id).subscribe(
      data => {
        this.updateUserReportsCount();
        if (data.status != 1)
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie dodano raportu do zapisanych");
        else
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, 'Dodano raport do zapisanych');
      },
      error=> {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie dodano raportu do zapisanych");
      }
    )
  }

  private filterReportClick() {
    this.showFilterPopup = false;
    this.getSuggestedReports(true);
    this.reportsAreFiltered = true;
  }

  private clearFiltersClick() {
    this.showFilterPopup = false;
    this.fileFormatsSelected = [];
    this.contentTypesSelected = [];
    this.thematicsAreasSelected = [];
    this.thematicsClientGroupsSelected = [];
    this.thematicsInstitutionsSelected = [];
    this.thematicsProductsSelected = [];
    this.thematicsPublicationFrequenciesSelected = [];
    this.reportsAreFiltered = false;
    this.getSuggestedReports(true);
  }

  modifySelectedObjectList(objectList : Array<Dictionary>, object : Dictionary, showResults? : boolean) {
    if (showResults === undefined)
      showResults = false;

    let position = objectList.indexOf(object);
    if (position === -1)
      objectList.push(object);
    else
      objectList.splice(position, 1);

    this.numberOfFilterCriteria = this.fileFormatsSelected.length
      + this.thematicsAreasSelected.length
      + this.thematicsClientGroupsSelected.length
      + this.thematicsPublicationFrequenciesSelected.length
      + this.thematicsInstitutionsSelected.length
      + this.thematicsProductsSelected.length
      + this.contentTypesSelected.length;

    this.getSuggestedReports(showResults);
  }

  downloadReportClick(report : Report) {
    this.commonService.downloadReportFile(report.id).subscribe(
      data=> {
        saveAs(data, report.fileName);
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać wskazanego raportu")
      }
    )
  }

  closeDownloadDemoPopup() {
    this.reportToOperateOn = undefined;
    this.showDownloadDemoPopup = false;
  }

  openDownloadDemoPopup(report : Report) {
    this.reportToOperateOn = report;
    this.showDownloadDemoPopup = true;
  }

  openContactFormPopup() {
    this.showContactFormPopup = true;
    let contactFormMessage = "Dzień dobry,\n\n".concat("poproszę o ofertę dotyczącą dostępu do raportu \"",
      this.reportToOperateOn.title,"\"\n\n", "Pozdrawiam\n\n", this.loggedUser.firstName, ' ', this.loggedUser.lastName);

    this.contactForm.controls['message'].setValue(contactFormMessage);
    this.commonService.registerClickOnElement('clickOnAskForOffer','suggestedReportsList', 'report', this.reportToOperateOn.id).subscribe(
      success => {
        if (success.status != 1)
          console.log(success.message);
      },
      error => {
        console.log(error);
      }
    );
  }

  closeContactFormPopup() {
    this.showContactFormPopup = false;
    this.contactFormMessage = '';
    this.contactForm.controls['agreement'].setValue(false);
    this.contactForm.controls['sendCopy'].setValue(false);
  }

  downloadDemoClick() {
    this.commonService.downloadDemoFile(this.reportToOperateOn.id).subscribe(
      data=>{
        saveAs(data, this.reportToOperateOn.demoFileName);
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać DEMO wskazanego raportu")
      }
    )
  }
  sendAccesRequestToReportClick() {
    let email = this.contactForm.controls['email'].value;
    let message = this.contactForm.controls['message'].value;
    let sendCopy = this.contactForm.controls['sendCopy'].value;
    this.commonService.sendAccessRequestUrl(this.loggedUser.id, this.reportToOperateOn.id, message, sendCopy).subscribe(
      result => {
        if (result.status ==1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Wysłano prośbę o dostęp do raportu");
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie wysłano maila z prośbą o dostęp")
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie wysłano maila z prośbą o dostęp")
      }
    );
    this.closeContactFormPopup();
  }



}
